export default (vm,ex)=>{
    vm.$el && vm.$loading.hide().$nodata.hide()
    if (({}).toString.call(ex) === "[object Error]") {
        let code = ex.code || ex.message || ex.error || '';
        if(!isNaN(code)) {
            let t = vm.i18n.t('code-'+code),
                msg = ((t == 'code-'+code)?void 0 : t) || ex.message || ex.error || '';
            if (code == 101 || code == -1) vm.$nodata.show()
            else vm.$el && vm.$nodata.show(`<pre style="text-align:left;">Code ${code}: ${msg}</pre>`)
        }else vm.$el && vm.$nodata.show(`<pre style="text-align:left;"> ${JSON.stringify(ex)}</pre>`)
    } else vm.$el && vm.$nodata.show(`<pre style="text-align:left;">${JSON.stringify(ex)}</pre>`)
    return;
}